// const auth = useAuth();

// import { AuthMethods, useAuth } from "~/composables/useAuth";

export const useCurrentUser = async () => {
  const auth = useAuth();
  return await auth.currentUser();
}
